import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { USAGE_REPORT_SECTIONS } from '../../data';

import './UsageReportSectionsList.styles.scss';

type UsageReportSectionsListProps = {
  className?: string;
};

const UsageReportSectionsList: React.FC<UsageReportSectionsListProps> = (
  props,
) => {
  const { className } = props;

  const { t } = useTranslation();

  const classes = classNames('usage-report-sections-list', className);

  return (
    <ol className={classes}>
      {USAGE_REPORT_SECTIONS.map(({ titleKey, descriptionKey }, index) => (
        <li key={titleKey}>
          <span className="usage-report-sections-list__note">{index + 1}</span>

          <div>
            <p className="usage-report-sections-list__title">{t(titleKey)}</p>
            <p className="usage-report-sections-list__note">
              {t(descriptionKey)}
            </p>
          </div>
        </li>
      ))}
    </ol>
  );
};

export default UsageReportSectionsList;
